module.exports = __webpack_public_path__ + "static/media/VikasPandey121.54f5a195.png";